import { SyntheticEvent } from 'react'

export default function stopPropagation<T = Element>(event: SyntheticEvent<T>) {
  event.stopPropagation()
}

export const withStopPropagation =
  <E extends SyntheticEvent>(fn?: (event: E) => any) =>
  (event: E) => {
    stopPropagation(event)
    return fn && fn(event)
  }
